import * as types from "../types/jobs";

const initialState = {
  jobs: [],
  selectedJob: {},
  isWorking: '',
  company: '',
  loading: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.LOADING_JOB: 
      return {
        ...state,
        loading: true,
        success: false,
      };
    case types.SUCCESS_JOB:
      return {
        ...state,
        jobs: action.payload,
        loading: false,
        success: true
      };
	  case types.SET_SELECTED_JOB:
	  	return {
			  ...state,
			  selectedJob: action.payload,
		  };
    case types.SET_WORK_STATUS:
      return {
        ...state,
        isWorking: action.payload,
      };
    case types.SET_COMPANY:
      return {
        ...state,
        company: action.payload
      };
    default:
      return state;
  }
};